import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/student/notifications").then(res => {
      setNotifications(res.data || []);
    });
  }, []);

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          <Header />

          <h2>🔔 Notifications</h2>
            <button
              onClick={() => nav("/user/dashboard")}
              style={backBtnStyle}
            >
              ← Back to Dashboard
            </button>

          {notifications.length === 0 && <p>No notifications</p>}

          {notifications.map(n => (
            <div key={n.id} style={notifCard}>
              <p>{n.message}</p>
              <small>{new Date(n.created_at).toLocaleString()}</small>
              {n.ticket_id && (
                <button onClick={() => nav(`/student/support/${n.ticket_id}`)} style={backBtnStyle}>
                  View
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function Header() {
  return (
    <div style={{ textAlign: "center", marginBottom: 20 }}>
      <img src="/logo.png" alt="EduAt10" style={{ width: 120 }} />
    </div>
  );
}

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
};
const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};
const cardStyle = {
  maxWidth: 1000,
  margin: "auto",
  background: "#fff",
  borderRadius: 16,
  padding: 30,
};
const notifCard = {
  padding: 12,
  border: "1px solid #ddd",
  borderRadius: 6,
  marginBottom: 10,
};
const backBtnStyle = {
  padding: "10px 16px",
  background: "#02884e",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 500,
};
